/**
 * 搜尋紀錄頁面模組
 */

//-----------------------------------------------------------------------
// 載入模組
import * as React from 'react';
import { List, Datagrid, DateInput, SelectInput, ReferenceInput, ReferenceArrayInput, AutocompleteArrayInput, TopToolbar, ExportButton } from 'react-admin';
import { TextField, DateField, ReferenceField } from 'react-admin';
import { downloadCSV, DataProvider } from 'react-admin';
import jsonExport from 'jsonexport/dist';

//-----------------------------------------------------------------------
// defines

//-----------------------------------------------------------------------
/** 搜尋紀錄列表過濾器。 */
const searchLogFilters =
[
	<ReferenceInput key='input-source' label='資料來源' source='sourceId' reference='source' resettable alwaysOn >
		<SelectInput optionText='name' />
	</ReferenceInput>,
	<ReferenceArrayInput key='input-keyword' label='關鍵字' source='keywordId' reference='keywordAll'>
		<AutocompleteArrayInput optionText='text' />
	</ReferenceArrayInput>,
	<DateInput key='input-logDate' source='logDate' label='紀錄月份' alwaysOn />
];

const ListActions = () => (
    <TopToolbar>
        <ExportButton maxResults={100000} />
    </TopToolbar>
);

/** 資料輸出功能。 */
const exporter = (records: any, fetchRelatedRecords: (data: any, field: string, resource: string) => Promise<any>, dataProvider: DataProvider) =>
{
	fetchRelatedRecords(records, 'sourceId', 'source').then((sources) =>
	{
		fetchRelatedRecords(records, 'keywordId', 'keyword').then((keywords) =>
		{
			fetchRelatedRecords(records, 'channelId', 'channel').then((channels) =>
			{
				fetchRelatedRecords(records, 'targetId', 'target').then((targets) =>
				{
					const data = records.map((record: any) =>
					{
						return {
							...record,
							sourceId: sources[record.sourceId].name,
							keywordId: keywords[record.keywordId].text,
							channelId: channels[record.channelId].name,
							targetId: targets[record.targetId].title
						};
					});

					return jsonExport(data,
					{
						headers	: [ 'id', 'sourceId', 'keywordId', 'channelId', 'targetId', 'ranking', 'logDate' ],
						rename	: [ 'id', '資料來源', '關鍵字', '所屬頻道', '目標', '搜尋排名', '紀錄日期' ]
					}, (err, csv) =>
					{
						downloadCSV("\ufeff" + csv, 'searchLog');
					});
				});
			});
		});
	});
};

/** 搜尋紀錄列表頁面。 */
export const SearchLogList = (props: any) =>
{
	return <List {...props} title='搜尋紀錄' sort={{ field: 'ranking', order: 'ASC' }} filters={searchLogFilters} actions={<ListActions />} exporter={exporter} >
		<Datagrid bulkActionButtons={false}>
			<TextField source='id' />
			<ReferenceField label="資料來源" source="sourceId" reference="source" >
				<TextField source="name" />
			</ReferenceField>
			<ReferenceField label="關鍵字" source="keywordId" reference="keyword" >
				<TextField source="text" />
			</ReferenceField>
			<ReferenceField label="所屬頻道" source="channelId" reference="channel" >
				<TextField source="name" />
			</ReferenceField>
			<ReferenceField label="目標" source="targetId" reference="target" >
				<TextField source="title" />
			</ReferenceField>
			<TextField source='ranking' label='搜尋排名' />
			<DateField source='logDate' label='紀錄日期' />
		</Datagrid>
	</List>;
};
